import React from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'core/utils/dayjs';
import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';
import PremierMerchantRebate from 'core/modules/PremierMerchantRebate/PremierMerchantRebate';
import OfferOverlayLink from 'core/modules/OfferOverlayLink/OfferOverlayLink';

import { selectFeaturedDealsConfig } from 'core/modules/FeaturedDeals/selectors';

import './FeaturedDealMobileClassic.scss';

function FeaturedDealMobileClassic({ config = {}, offer }) {
  const componentConfig = useSelector(selectFeaturedDealsConfig);
  const combinedConfig = { ...componentConfig, ...config };

  const {
    id, assets, couponCode, merchant, isOngoing, codeText, expires,
  } = offer;

  const {
    contentApi,
    api,
    useAddToFavorite,
    rebateMobileOptions,
    shouldTrackInitialParams,
  } = combinedConfig;
  const sectionId = contentApi?.options?.sectionId || api?.options?.sectionId;
  const expiresToDisplay = dayjs.parseZone(expires).format('M/DD/YY');

  return (
    <div
      className="mn_featuredDeal mn_featuredDealMobileClassic mn_favoriteItemWrap"
      data-testid="featured-deal-mobile-classic"
    >
      <div className="mn_favoriteIconWrap">
        {useAddToFavorite &&
          <FavoriteIcon
            merchantId={merchant.id}
            merchantName={merchant.name}
            tooltipClassName="mn_featuredDealToolTip"
          />
        }
      </div>
      <OfferOverlayLink
        merchantId={merchant.id}
        merchantName={merchant.name}
        offerId={id}
        sectionId={sectionId}
        shouldTrackInitialParams={shouldTrackInitialParams}
      >
        <div className="mn_merchantLogoWrap">
          <img src={merchant.logoUrls._120x60} alt={merchant.name} />
        </div>
        <div className="mn_offerItemContent">
          <div className="mn_offerDetailsAndExpiryWrap">
            <span
              data-text={assets.rolloverCopy}
              data-merchant-name={merchant.name}
              className="mn_rolloverCopy"
              dangerouslySetInnerHTML={{ __html: assets.rolloverCopy }}
            />
            <span className="mn_expire">
              {' '}{isOngoing ? <>Ongoing</> : <>Valid thru {expiresToDisplay}</>}
            </span>
          </div>
          <PremierMerchantRebate
            {...merchant.rebate}
            {...rebateMobileOptions}
          />
          { couponCode &&
            <div className="mn_couponCodeWrap">
              <span className="mn_couponCodeLabel">{codeText || 'Use code:'} </span>
              <p className="mn_couponCode">{couponCode}</p>
            </div>
          }
        </div>
      </OfferOverlayLink>
    </div>
  );
}

export default FeaturedDealMobileClassic;
